
import { FavoritePage } from '@/model/preferences-utilisateur/favorite-page';
import { PreferencesUtilisateur } from '@/model/preferences-utilisateur/preferences-utilisateur';
import { RouteName } from '@/router/routes';
import { cloneDeep } from 'lodash';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'FavoritePage',
  data () {
    return {
      canDisplay: true,
      loading: false
    };
  },
  watch: {
    $route (to, from) {
      const allowedRoutes = [
        RouteName.MAIN_DASHBOARD,
        RouteName.MAIN_DETAIL,
        RouteName.MAIN_ALERTE_UTILISATEUR,
        RouteName.MAIN_HISTORIQUE_COMMANDES,
        RouteName.MAIN_MON_COMPTE
      ];
      this.canDisplay = allowedRoutes.includes(to.name);
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapGetters({ preferencesUtilisateur: 'preferenceUtilisateur/preferenceUtilisateur', user: 'user/user' }) as {
      preferencesUtilisateur: () => PreferencesUtilisateur,
      user: () => any
    },
    isFavoritePage (): boolean {
      if (!this.preferencesUtilisateur.favoritePage) return false;
      return this.$route.name === this.preferencesUtilisateur.favoritePage.name && JSON.stringify(this.$route.params) === JSON.stringify(this.preferencesUtilisateur.favoritePage.params);
    }
  },
  methods: {
    ...mapActions({ savePreferencesUtilisateur: 'preferenceUtilisateur/savePreferenceUtilisateur' }),
    updateFavoritePage () {
      this.loading = true;
      const newPreferencesUtilisateur = new PreferencesUtilisateur();
      newPreferencesUtilisateur.favoritePage = this.isFavoritePage ? null : new FavoritePage(this.$route.name, this.$route.params);
      this.savePreferencesUtilisateur({ utilisateur: this.user.username, preferenceUtilisateur: newPreferencesUtilisateur })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        }).finally(() => {
          this.loading = false;
        });
    }
  }
});
